import React from "react";
import { useTranslation } from "react-i18next";
import "./hyaiaGathers.scss";

const HyaiaGathers = () => {
  const {t} =  useTranslation()
  return (
    <div className="container-hyaia-gathers">
      <div data-aos="fade-right" className="texts-hyaia-gathers">
        <h1>{t("home.hyaia_gathers.title")}</h1>
      </div>
    </div>
  );
};
export default HyaiaGathers;
